/**
 * Stat Block Script
 *
 * Animates the stat number counting up on scroll into view.
 *
 * This file is compiled by Vite with ES6+ support.
 * CSS is compiled separately - do not import it here.
 */

import { initCountUp } from '@/count-up';

document.addEventListener('DOMContentLoaded', () => {
	const blocks = document.querySelectorAll('.rmh-stat');

	blocks.forEach((block) => {
		initCountUp(block);
	});
});
